import { render, staticRenderFns } from "./studentLive.vue?vue&type=template&id=142c3a1c&"
import script from "./studentLive.vue?vue&type=script&lang=js&"
export * from "./studentLive.vue?vue&type=script&lang=js&"
import style0 from "./studentLive.vue?vue&type=style&index=0&id=142c3a1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports